module.exports = __webpack_public_path__ + "img/1.d10b5598.png";